<ion-header mode="ios">
  <ion-toolbar mode="ios" color="light">
    <ion-title>Log Filters</ion-title>
    <ion-buttons slot="start">
      <ion-button mode="ios" fill="clear" (click)="dismiss()" tappable>
        <ion-icon color="dark" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list lines="none" mode="ios">
    <h6 class="ion-text-left ion-padding-start">Severity</h6>
    <ion-radio-group mode="md" [(ngModel)]="selectedLevel">
      <ion-item mode="ios" (click)="selectedLevel = ''">
        <ion-label>All severities</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="selectedLevel = 'INFO'">
        <ion-label>Info</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="INFO" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="selectedLevel = 'WARNING'">
        <ion-label>Warning</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="WARNING" color="warning"></ion-radio>
      </ion-item>
      <ion-item mode="ios" (click)="selectedLevel = 'ERROR'">
        <ion-label>Error</ion-label>
        <ion-radio slot="start" class="custom-radio" mode="md" value="ERROR" color="warning"></ion-radio>
      </ion-item>
    </ion-radio-group>

    <h6 class="ion-text-left ion-padding-start">Scope</h6>
    <div class="filter-grid">
      <ion-item mode="ios">
        <ion-label position="stacked">Area</ion-label>
        <ion-select [(ngModel)]="area" interface="popover" aria-label="Log area">
          <ion-select-option value="">All log areas</ion-select-option>
          @for (option of areas; track option.value) {
            <ion-select-option [value]="option.value">{{ option.label }}</ion-select-option>
          }
        </ion-select>
      </ion-item>
      <ion-item mode="ios">
        <ion-label position="stacked">Environment</ion-label>
        <ion-input [(ngModel)]="environment" placeholder="dev, prod"></ion-input>
      </ion-item>
      <ion-item mode="ios">
        <ion-label position="stacked">Operation</ion-label>
        <ion-input [(ngModel)]="operation" placeholder="function or method"></ion-input>
      </ion-item>
      <ion-item mode="ios">
        <ion-label position="stacked">User/Admin ID</ion-label>
        <ion-input [(ngModel)]="actorId" placeholder="safe actor id"></ion-input>
      </ion-item>
      <ion-item mode="ios">
        <ion-label position="stacked">Correlation ID</ion-label>
        <ion-input [(ngModel)]="correlationId" placeholder="request or trace id"></ion-input>
      </ion-item>
    </div>

    <h6 class="ion-text-left ion-padding-start">Date Range</h6>
    <div class="filter-grid">
      <ion-item mode="ios">
        <ion-label position="stacked">From</ion-label>
        <ion-input [(ngModel)]="startDate" type="date"></ion-input>
      </ion-item>
      <ion-item mode="ios">
        <ion-label position="stacked">To</ion-label>
        <ion-input [(ngModel)]="endDate" type="date"></ion-input>
      </ion-item>
    </div>
  </ion-list>
</ion-content>

<ion-footer mode="ios">
  <ion-grid class="ion-no-padding">
    <ion-row>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
      <ion-col sizeXl="7" sizeLg="7" sizeMd="10" sizeSm="12" sizeXs="12">
        <ion-row>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="apply()">Apply</ion-button>
          </ion-col>
          <ion-col size="6">
            <ion-button mode="ios" color="warning" expand="full" shape="round" (click)="clear()">Clear</ion-button>
          </ion-col>
        </ion-row>
        <br />
      </ion-col>
      <ion-col sizeXl="2.5" sizeLg="2.5" sizeMd="1" sizeSm="0" sizeXs="0"></ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>
